module.exports = __webpack_public_path__ + "static/media/t_ubc.ce2c22a2.png";